<section class="expense-directory">
  <header class="expenses-toolbar">
    <div>
      <h1>{{ pageTitle }}</h1>
      <span>{{ pageDescription }}</span>
    </div>
  </header>

  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="expenses-panel" *ngIf="isListMode">
    <div class="panel-tools">
      <div>
        <h2>Список расходов</h2>
        <span>{{ expenses.length }} расходов</span>
      </div>
      <a class="action-button panel-add-button" routerLink="/dashboard/expenses/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить</span>
      </a>
    </div>

    <div class="expenses-table-wrap" *ngIf="sortedExpenses.length > 0; else emptyExpenses">
      <table class="expenses-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('title')" [attr.aria-sort]="sortState('title')">Расход <span>{{ sortMark('title') }}</span></button></th>
            <th><button type="button" (click)="setSort('scope')" [attr.aria-sort]="sortState('scope')">Тип <span>{{ sortMark('scope') }}</span></button></th>
            <th><button type="button" (click)="setSort('category')" [attr.aria-sort]="sortState('category')">Категория <span>{{ sortMark('category') }}</span></button></th>
            <th><button type="button" (click)="setSort('binding')" [attr.aria-sort]="sortState('binding')">Привязка <span>{{ sortMark('binding') }}</span></button></th>
            <th><button type="button" (click)="setSort('amount')" [attr.aria-sort]="sortState('amount')">Сумма <span>{{ sortMark('amount') }}</span></button></th>
            <th><button type="button" (click)="setSort('responsible')" [attr.aria-sort]="sortState('responsible')">Ответственный <span>{{ sortMark('responsible') }}</span></button></th>
          </tr>
        </thead>
        <tbody>
          <tr class="expense-row" *ngFor="let expense of sortedExpenses; trackBy: trackById" [routerLink]="['/dashboard/expenses', getExpenseRoute(expense), 'edit']">
            <td>
              <strong>{{ expense.code }}</strong>
              <span>{{ expense.title }}</span>
            </td>
            <td><span class="scope-pill" [class.monthly]="expense.scope === 'monthly'">{{ getExpenseScopeName(expense.scope) }}</span></td>
            <td>{{ expense.category?.name || 'Без категории' }}</td>
            <td>{{ getExpenseBinding(expense) }}</td>
            <td><strong>{{ formatMoney(expense.amount) }}</strong></td>
            <td>{{ expense.createdByUser?.displayName || expense.createdByUser?.username || 'Неизвестно' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyExpenses>
      <div class="empty-state">{{ loading ? 'Обновляем расходы...' : 'Расходы пока не добавлены.' }}</div>
    </ng-template>
  </section>

  <section class="expense-editor" *ngIf="!isListMode">
    <form class="editor-layout" (ngSubmit)="saveExpense()">
      <div class="editor-main">
        <section class="form-panel">
          <h2>Основное</h2>
          <div class="form-grid">
            <label class="wide">
              <span>Название</span>
              <input class="form-control" name="expenseTitle" placeholder="Продвижение Авито" [(ngModel)]="formData.title">
            </label>

            <label>
              <span>Категория</span>
              <select class="form-control" name="expenseCategory" [(ngModel)]="formData.categoryId">
                <option [ngValue]="null" disabled>Выберите категорию</option>
                <option *ngFor="let category of categories; trackBy: trackById" [ngValue]="category.id">{{ category.name }}</option>
              </select>
            </label>

            <label>
              <span>Сумма</span>
              <input class="form-control" type="number" min="0" name="expenseAmount" placeholder="900" [(ngModel)]="formData.amount">
            </label>

            <label class="wide">
              <span>Описание</span>
              <textarea class="form-control textarea" rows="5" name="expenseComment" placeholder="Например: поднятие объявления или оплата тарифа" [(ngModel)]="formData.comment"></textarea>
            </label>
          </div>
        </section>

        <section class="form-panel">
          <h2>Привязка</h2>
          <div class="scope-switch" aria-label="Тип расхода">
            <button type="button" [class.active]="formData.scope === 'event'" (click)="setScope('event')">На событие</button>
            <button type="button" [class.active]="formData.scope === 'monthly'" (click)="setScope('monthly')">На месяц</button>
          </div>

          <label *ngIf="formData.scope === 'event'">
            <span>Событие в работе</span>
            <select class="form-control" name="expenseEventId" [(ngModel)]="formData.eventId" [disabled]="activeEvents.length === 0">
              <option [ngValue]="null">{{ activeEvents.length === 0 ? 'Нет событий в работе' : 'Выберите событие' }}</option>
              <option *ngFor="let event of activeEvents; trackBy: trackById" [ngValue]="event.id">{{ getEventOptionLabel(event) }}</option>
            </select>
            <small *ngIf="activeEvents.length === 0">Расход на событие можно привязать к событию со статусом «В работе».</small>
          </label>

          <label *ngIf="formData.scope === 'monthly'">
            <span>Месяц расхода</span>
            <input class="form-control" type="month" name="expenseMonth" [(ngModel)]="formData.month">
          </label>
        </section>
      </div>

      <aside class="editor-side">
        <section class="form-panel actions-panel">
          <h2>Действия</h2>
          <button class="action-button primary" type="submit" [disabled]="saving">{{ submitButtonLabel }}</button>
          <button class="action-button danger" type="button" *ngIf="mode === 'edit'" [disabled]="saving" (click)="deleteExpense()">Удалить расход</button>
          <a class="action-button ghost" routerLink="/dashboard/expenses">Назад к списку</a>
        </section>

        <section class="form-panel details-panel" *ngIf="editingExpense">
          <h2>Детали</h2>
          <dl>
            <div><dt>Идентификатор</dt><dd>{{ editingExpense.code }}</dd></div>
            <div><dt>Добавлен</dt><dd>{{ formatDate(editingExpense.createdAt) }}</dd></div>
            <div><dt>Изменен</dt><dd>{{ formatDate(editingExpense.updatedAt) }}</dd></div>
            <div><dt>Ответственный</dt><dd>{{ editingExpense.createdByUser?.displayName || editingExpense.createdByUser?.username || 'Неизвестно' }}</dd></div>
          </dl>
        </section>
      </aside>
    </form>
  </section>
</section>
